import * as React from "react"

export const GoIcon = (props) => {
    return (
        <svg width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M32 63.5C49.397 63.5 63.5 49.397 63.5 32C63.5 14.603 49.397 0.5 32 0.5C14.603 0.5 0.5 14.603 0.5 32C0.5 49.397 14.603 63.5 32 63.5Z" stroke={props.circleColor || 'white'}/>
            <path d="M22.0252 33.013L41.0423 33.0721L36.1728 28.3664" stroke={props.arrowColor || 'white'}/>
        </svg>
    )
}